export enum InputState {
  success = "success",
  progress = "progress",
  error = "error",
}

export type FieldState = {
  state?: InputState
  stateText?: string
}